"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modals = void 0;
var React = require("react");
var RemoveModal_1 = require("../RemoveModal");
var ScheduledRemoveModal_1 = require("../ScheduledRemoveModal");
var CreateSubproject_1 = require("../../CreateSubproject");
var ArchiveSubproject_1 = require("../../ArchiveSubproject");
var Modals = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement(RemoveModal_1.RemoveModal, __assign({}, props)),
    React.createElement(ScheduledRemoveModal_1.ScheduledRemoveModal, __assign({}, props)),
    React.createElement(CreateSubproject_1.CreateSubprojectModal, { subprojectIsOpen: props.createSubprojectIsOpen, setSubprojectIsOpen: props.setCreateSubprojectIsOpen, currentFolder: props.currentFolder, metadata: props.metadata }),
    React.createElement(ArchiveSubproject_1.ArchiveSubprojectModal, { subprojectIsOpen: props.archiveSubprojectIsOpen, setSubprojectIsOpen: props.setArchiveSubprojectIsOpen, selected: props.selectedItems.length === 1 ? props.selectedItems[0] : null }))); };
exports.Modals = Modals;
